import { useMemo, useState } from "react";
import jwtDecode from "jwt-decode";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { PureAbility } from "@casl/ability";
import LoadingSpinner from "@components/loading-spinner/LoadingSpinner";
import { useAbortableEffects } from "@helpers/useAbortableEffects";
import { lazy } from "@loadable/component";
import { AbilityContext } from "@metronic/_context/Can";

import Layout from "../_metronic/layout/components/Layout";
import store from "../redux/store";

import Logout from "./modules/Auth/pages/Logout";
import { ErrorPage3 } from "./modules/Errors/ErrorPage3";
import ProtectedRoute from "./routes/ProtectedRoute";
import { useGetUserPermissions } from "./_apiArchem";
import BlankLayout from "./BlankLayout";
import { getRoutes } from "./routes";

const LandingPage = lazy(() => import("../app/pages/landing/LandingPage"));
const AuthPage = lazy(() => import("../app/modules/Auth/pages/AuthPage"))
const HomePage = lazy(() => import("../app/pages/home/Home"))

const NotAuthorized = lazy(() => import("./pages/NotAuthorized"))

const SalesContractConfirm = lazy(() => import("./pages/PurchaseOrderConfirm/SalesContractConfirm"))


const ArchemRouter = () => {
  const { auth: { authToken } } = store.getState();
  const [isGetUserPermissions, setIsGetUserPermissions] = useState(false);
  const [isAbilitiesLoaded, setAbilitiesLoaded] = useState(false);

  useAbortableEffects(() => {
    try {
      if (authToken && (jwtDecode(authToken)?.exp < Date.now() / 1000)) {
        sessionStorage.clear();
        setAbilitiesLoaded(true)
      } else {
        setIsGetUserPermissions(true);
      }
    } catch (error) {
      setAbilitiesLoaded(true)
      sessionStorage.clear();
    }
  }, [])

  const _apiUserPermissions = useGetUserPermissions(isGetUserPermissions)
  const [ability, setAbility] = useState(new PureAbility());

  useAbortableEffects(() => {
    setAbility(new PureAbility(_apiUserPermissions.data || []))
    if (_apiUserPermissions.data) {
      setAbilitiesLoaded(true)
    }
  }, [_apiUserPermissions.data])

  const allRoutes = useMemo(() => getRoutes(), []);

  const routes = createBrowserRouter([
    {
      path: '/notauthorized',
      element: <NotAuthorized />
    },
    {
      path: "/salescontract/confirmreceipt/:sales_contract_id/:noa_uuid",
      element: <SalesContractConfirm />
    },
    {
      path: "/",
      element: <BlankLayout />,
      children: [
        { index: true, element: <LandingPage /> },
        { path: '/auth/login', element: <AuthPage /> }
      ]
    },
    {
      path: '/',
      element: <ProtectedRoute />,
      children: [
        {
          element: <Layout />,
          children: [
            { path: '/home', element: <HomePage /> },

          ]
        }
      ],
    },
    {
      path: "/logout",
      element: <Logout />
    },
    {
      element: <Layout />,
      children: [
        {
          path: '/notauthorized',
          element: <NotAuthorized />
        },
        {
          path: '*',
          element: <ErrorPage3 />
        }
      ]
    },
    ...allRoutes
  ])

  // return <AbilityContext.Provider value={ability}><RouterProvider router={r} /></AbilityContext.Provider>;
  return (!isAbilitiesLoaded && !isGetUserPermissions) ? <LoadingSpinner /> :
    <AbilityContext.Provider value={ability}>
      <RouterProvider router={routes} />
    </AbilityContext.Provider>;
};

export default ArchemRouter;
